export default "__VITE_ASSET__0089d6b6__"